import React from "react";

function NewFeatures() {
  return (
    <div className="mt-10">
      <div className=" max-w-7xl mx-5 sm:mx-auto bg-black text-white rounded-2xl px-8 py-10 my-10 shadow-lg">
        <h2 className="text-base font-semibold text-left mb-6">
          Exciting New Features and Courses Coming Soon!
        </h2>
        <p className="text-sm  text-left leading-relaxed">
          At Academy-nest, we are constantly evolving to bring you the best
          learning experience. Stay tuned for innovative features and a variety of
          new courses designed to empower your learning journey.
        </p>
      </div>
    </div>
  );
}

export default NewFeatures;
